import API from "../index";

export const loginService = async (credentials) => {
  return API.post("/admin/login", credentials);
};
